import makeCrud from '@/store/site/localization/crud'
const module = makeCrud('manager_segment')
module.actions.preview = async function (_, { match, rules }) {
    const res = await this._vm.axios.post(this._vm.endpoint.get('manager_segment_preview'), { match, rules })
    return res.data
}
export default module
